import isEmpty from 'lodash/isEmpty';
import { APIClient, JavaAPIClient } from "../lib/apiHelper"
import { createFormDataFromObject } from '../helpers/helpers';
import FileSaver from 'file-saver';

/******************************************************************
 * 파일명 : frontend2\src\services\CompanyService.js
 * 메뉴 : 
 * URL  : 
 * 설명 :
 ******************************************************************/

const { get, post, put, remove, post2, put2 } = new APIClient();
const { get: _get, put: _put, post: _post, remove: _remove, post2: _post2 } = new JavaAPIClient();


export default {
	/**
	 * 회사 검색
	 * @method GET
	 * @param {OBJECT} search
	 * =========================
	 * @param {STRING} name
	 * @param {STRING} tel
	 * @param {STRING} address
	 * @param {STRING} count
	 * @param {STRING} offset
	 * @param {STRING} order
	 * @param {STRING} desc
	 */
	search: (search) => _get(`/company?${search ? new URLSearchParams(search).toString() : ''}`),

	me: (companyId) => get('/company/me?companyId=' + companyId),

	info: (search) => _get(`/company/info?${search ? new URLSearchParams(search).toString() : ''}`),

	logo: (search) => _get(`/company/logo?${search ? new URLSearchParams(search).toString() : ''}`),

	personalInfo: (companyId, userId) => _get('/personalInfo?companyId=' + companyId + '&userId=' + userId),

	restInfoList: (param) => post('/restInfoList', param),
	searchRequestList: (param) => post('/requestList', param),
	attendList: (companyId) => get('/attend/list?companyId=' + companyId),
	requestProceedingList: (companyId) => get('/request/proceed/list?companyId=' + companyId),
	attendCheckList: (companyId) => get('/attend/check/list?companyId=' + companyId),
	getVacationStatus: (info) => _get(`/request/success/list?${info ? new URLSearchParams(info).toString() : ''}`),
	getRestOrWorkStatus: (info) => _get(`/request/success/getRestOrWorkStatus?${info ? new URLSearchParams(info).toString() : ''}`),
	getRquestDetail: (id) => _get(`/request/detail?id=${id}`),
	/**
	 * 사업자 등록번호 중복 조회
	 */
	checkCorporateRegiNumber: (number) => _get('/company/check/regiNumber?number=' + number),
	/**
	 * 회사 가입 여부 확인
	 */
	checkJoinedCompany: (email, companyId) => get(`/company/join/check?email=${email}` + '&companyId=' + companyId),
	/**
	 * 직원 개별 등록
	 */
	singleAdd: (invate) => post('/userCompany/joinCompanyDirect/single', invate),

	/**
	 * 연차 엑셀 다운로드
	 * @param {INTEGER} selectedYear
	 */
	restRecordDownload: (info) => _get(`/request/rest/download?${info ? new URLSearchParams(info).toString() : ''}`),

	/**
	 * 신청 목록
	 * @returns
	 */
	requestList: (request) => _get(`/request/list?${request ? new URLSearchParams(request).toString() : ''}`),

	/**
	 * 연차 신청 목록
	 * @method GET
	 * @param {INTEGER} companyId
	 */
	restdayRequestList: (companyId) => get('/attend/restday-request?companyId=' + companyId),
	/**
	 * 회사 생성
	 * @method POST
	 * @param {OBJECT} companyAnniversary
	 * =========================
	 * @param {STRING} name
	 * @param {STRING} tel
	 * @param {STRING} address
	 * @param {STRING} addressDetail
	 * @param {STRING} logo
	 */
	create: (company) => _post('/company', company),

	/**
	 * 참여한 회사 목록
	 * @method GET
	 */
	isExistCompany: (tel, companyId = 0) => get('/company/is-exist-company?tel=' + tel.replace(/-/gi, '') + '&companyId=' + companyId),

	/**
	 * 회사 참여
	 * @method POST
	 * @param {INTEGET} companyId
	 */
	joinRequest: (companyId) => put('/company/join-request', { companyId }),
	joinRequestConfirm: (data) => _put('/company/join-request-confirm', data),
	joinRequestDeny: (id) => _put('/company/join-request-deny', { id }),
	joinRequestList: (companyId) => _get('/company/new-face?companyId=' + companyId),

	/**
	 * 참여한 회사 목록
	 * @method GET
	 * @param {OBJECT} search
	 * =========================
	 * @param {STRING} name
	 * @param {STRING} tel
	 */
	myCompany: (search) => _get(`/company/my?${search ? new URLSearchParams(search).toString() : ''}`),

	/**
	 * 휴일 떙겨오기
	 * @param companyId
	 */
	newList: (companyId, groupId = undefined) => _get('/holiday/newList?companyId=' + companyId + (groupId !== undefined ? '&groupId=' + groupId : '')),
	/* new 휴일 가져오기 */
	holidayList: (companyId, year, userId = null) => _get('/holiday/list?companyId=' + companyId + '&year=' + year + (userId !== null ? '&userId=' + userId : '')),
	/**
	 * 휴일 추가
	 * @param {OBJECT} holiday
	 */
	addHoliday: (holiday) => _post('/holiday/add', holiday),
	addHolidayList: (holidays) => _post('/holiday/addList', holidays),
	deleteHolidayList: (companyId, ids) => _remove(`/holiday/deleteList?companyId=${companyId}`, ids),

	/**
	 * 휴일 삭제
	 * @method Remove
	 * @param {INTEGER} companyId
	 * @param holidayId
	 */
	deleteHoliday: (companyId, id) => _remove(`/holiday/delete?companyId=${companyId}&id=${id}`),

	/**
	 * 휴일 수정
	 * @method put
	 * @param {OBJECT} holiday
	 *
	 */
	putHoliday: (holiday) => _put(`/holiday/put`, holiday),
	/**
	 * 회사 정보 수정
	 * @param data
	 * @returns {Promise<AxiosResponse<any>>}
	 * 기존 /company/modifyCompany
	 */
	modifyCompany: (data) => _put('/company/modifyCompanyNew', data),

	/**
	 * 출근/퇴근 신청
	 * @method POST
	 * @param {INTEGER} companyId
	 * @param {INTEGER} areaId
	 * @param {STRING} attendType (ATTEND || LEAVE)
	 * @param {STRING} memo
	 */
	attend: (attend) => post('/attend', attend),

	/**
	 * 출근/퇴근 수정 요청
	 * @method PUT
	 * @param {INTEGER} id
	 * @param {STRING} memo
	 * @param {DATE} updatedAt
	 */
	attendModifyRequest: (attend) => put('/attend/modify-request', attend),

	/**
	 * 출근/퇴근 수정 (웹관리자용)
	 * @param {*} companyId
	 * @returns
	 */
	modifyWorkRecordRequest2: (attend) => _post('/request/modify-work-record2', attend),
	modifyWorkRecordRequest3: (attend) => _post('/request/modify-work-record3', attend),
	modifyWorkRecordRequest4: (attend) => _post('/request/modify-work-record4', attend),
	modifyWorkRecordRequestExcel: (params) => _post('/request/modify-work-record-excel', params),

	/**
	 * ccCode 수정 시 실행되는 로직
	 * @param {*} companyId
	 * @returns
	 */
	modifyScheduleAttend: (attend) => _post('/request/modify-schedule-attend', attend),

	/**
	 * 출근/퇴근 GPS 수정 (웹관리자용)
	 * @param {*} companyId
	 * @returns
	 */
	modifyWorkGpsRequest: (attend) => post('/request/modify-gps-record', attend),

	/**
	 * 연차 종류 목록
	 * @method GET
	 * @param {INTEGER} companyId
	 */
	restDayList: (companyId) => get(`/restday?companyId=${companyId}`),

	/** 연차 개별 설정
	* @method POST
	*/
	setRestOption: (users) => _post('/user/restInfo', users),


	/**
	 * 연차 신청
	 * @method POST
	 * @param {OBJECT} restday
	 * =========================
	 * @param {INTEGER} companyId
	 * @param {INTEGER} restdayId
	 * @param {STRING} memo
	 * @param {DATE} createdAt
	 */
	restdayRequest: (restday) => _post2('/attend/restday-request', restday),
	/**
	 * 이월 연차 신청
	 * @method POST
	 * @param {OBJECT} restday
	 * =========================
	 * @param {INTEGER} companyId
	 * @param {INTEGER} restdayId
	 * @param {DATE} createdAt
	 */
	restAccrualRequest: (restday) => _post('/request/rest-accrual', restday),

	/**
	* 파일 업로드
	* @method POST
	* @param {OBJECT} data
	* =========================
	* @param {INTEGER} companyId
	*/
	uploadFile: (data) => post('/file', data),
	deleteFile: (id) => get(`/file/${id}`),
	approvalUploadFile: (data) => post('file/approval', data),
	approvalDownloadFiles: (companyId, id, fileId) => get(`/e-approval/download/${companyId}/${id}/${fileId}`),

	/**
	 * 출근/퇴근 수정 요청 V2
	 * @method POST
	 * @param {OBJECT} workRecord
	 * =========================
	 * @param {INTEGER} companyId
	 * @param {INTEGER} restdayId
	 * @param {INTEGER} areaId
	 * @param {STRING} type
	 * @param {STRING} startTime
	 * @param {STRING} endTime
	 * @param {ARRAY} approval
	 * @param {STRING} state
	 * @param {STRING} memo
	 * @param {STRING} etc
	 * @param {DATE} startDate
	 * @param {DATE} endDate
	 * @param {OBJECT} addHistory
	 *
	 */
	modifyWorkRecord: (workRecord) => _post('/request/modify-work-record', workRecord),

	/**
	 * 근무/휴가 신청건 회수처리
	 * @param {*} detailId
	 */
	cancellationRequest: (detailId, etc = null, state = null) => _remove('/request/remove?detailId=' + detailId + (etc ? '&etc=' + etc : '') + (state ? '&state=' + state : '')),

	/**
	 * 연차 신청 승인
	 * @method PUT
	 * @param {INTEGER} id
	 * @param {BOOLEAN} ok
	 */
	restdayRequestConfirm: (id, ok) => put('/restday/request-confirm', { id, ok }),

	/**
	 * 신청 승인/반려
	 * @returns
	 */
	requestAccept: (request) => _post('/request/accept', request),
	/**
	 * 사용자 일괄 신청 승인/반려
	 * @returns
	 */
	requestAcceptAll: (request) => post('/request/accept-all', request),

	/**
	 * 사용자 목록
	 * @method GET
	 * @param {INTEGER} companyId
	 */
	userListByPermissions: (companyId, type, years = null, size = null, page = null, filters = []) => {
		const params = new URLSearchParams({ companyId, type, ...(years && { years }), ...(size && { size }), ...(page && { page }), ...(!isEmpty(filters) && { filters: JSON.stringify(filters) }) });
		return _get(`/company/usersByPermissions?${params}`);
	},
	userList: (companyId, years = null, size = null, page = null, filters = []) => {
		const params = new URLSearchParams({ companyId, ...(years && { years }), ...(size && { size }), ...(page && { page }), ...(!isEmpty(filters) && { filters: JSON.stringify(filters) }) });
		return _get(`company/users?${params}`);
	},
	userListOne: (companyId, userIds, years = '') => _get(`/company/users?companyId=${companyId}&users=${userIds}&years=${years}`),
	/**
	 * 퇴사자 목록
	 * @param companyId
	 * @returns {Promise<AxiosResponse<any>>}
	 */
	leaveList: (companyId) => get('/company/leave?companyId=' + companyId),

	/**
	 * 퇴사 하기
	 * @method PUT
	 * @param {INTEGER} companyId
	 * @param userId
	 */
	leave: (companyId, userId = null) => put('/company/leave', { companyId, userId }),

	/**
	 * 퇴사 하기
	 * @method PUT
	 * @param {INTEGER} companyId
	 * @param userId
	 */
	deleteLeaveData: (companyId, userId) => remove(`/company/leave?companyId=${companyId}&userId=${userId}`),

	/**
	 * 현재 회사 선택
	 * @method PUT
	 */
	selectCompany: (companyId) => _put('/company/select', { companyId }),
	/**
	 * 관리자 정보 수정하기
	 * @method PUT
	 * @param {INTEGER} companyId
	 * @param {ARRAY[INTEGER]} userId
	 */

	modifyAdminList: (companyId, userId) => put('/company/admin', { companyId, userId }),
	/**
	 * 휴가유형 정보 New
	 * @param {*} companyId
	 */
	getRestType: (companyId) => _get(`/restday/${companyId}`),

	/**
	 * 휴가 신청 휴가유형 정보 New
	 * @param {Object} param = {
	 * @param {INTEGER} companyId
	 * @param {Array} typeArray
	 */
	getUserRestType: (param) => _post(`/user/restday`, param),

	/**
	 * 휴가 사용 new
	 */

	userRestUseList: (year, companyId, userId) => get(`/userRestUse/list?year=${year}&companyId=${companyId}&userId=${userId}`),
	userRestUseAdd: (param) => post(`/userRestUse/add`, param),
	userRestUseMultiadd: (param) => _post(`/userRestUse/multiadd`, param),
	userRestDelete: (id) => _remove('/userRestUse?id=' + id),

	/**
	 *
	 *
	 * 근무유형 정보 New
	 * @method GET
	 * @param {INTEGER} companyId
	 */

	getWorkType: (companyId) => get(`/restDay/work/${companyId}`),

	attendWeekInfo: (attend) => _get(`/attend/weekInfo?${attend ? new URLSearchParams(attend).toString() : ''}`),

	attendMonthInfo: (attend) => _get(`/attend/monthInfo?${attend ? new URLSearchParams(attend).toString() : ''}`),

	/**
	 * 공휴일
	 * @method GET
	 * @param {INTEGER} companyId
	 */
	getHoliday: (companyId) => _get('/holiday?companyId=' + companyId),

	/**
	 * 공휴일
	 * @method GET
	 * @param {INTEGER} companyId
	 */
	getWorksystem: (companyId) => _get('/workSystem?companyId=' + companyId),

	/**
	 * 회사 오너아이디로 사용기한 출력하기
	 * @method GET
	 * @param {INTEGER} ownerUserId
	 */
	getPeriodOfUse: (ownerUserId) => get('/company/getperiodofuse?ownerUserId=' + ownerUserId),

	/**
	 * 공휴일
	 * @method GET
	 * @param {INTEGER} companyId
	 */
	saveGroup: (group) => _post('/workgroup/save2', group),

	/**
	 * 근무장소 추가
	 * @method POST
	 *
	 */
	addWorkingArea: (area) => _post('/area', area),

	/**
	 * 근무장소 수정
	 * @method POST
	 * @param {INTEGER} areaId
	 *
	 */
	editWorkingArea: (areaId) => _put('/area', areaId),

	/**
	 * 근무지 목록
	 * @method GET
	 * @param {INTEGER} companyId
	 */
	getWorkingArea: (companyId, userId, isOnOffWork = false, isMobile = false) => _get(`/area/id?companyId=${companyId}${userId !== undefined ? '&userId=' + userId : ''}&onOffWork=${isOnOffWork}&isMobile=${isMobile}`),

	/**
	 * 전체인원 조회
	 * @method GET
	 * @param {INTEGER} companyId
	 */
	getAllUser: (companyId) => _get(`/userCompany/getAllUser?companyId=${companyId}`),

	/**
	 * 근무장소 삭제
	 * @method DELETE
	 * @param {INTEGER} areaId
	 *
	 */
	deleteWorkingArea: (areaId) => _remove('/area/id?areaId=' + areaId),

	/**
	 * 근무장소 검색
	 * @method GET
	 * @param {INTEGER} areaId
	 *
	 */
	getById: (areaId) => get('/area/areaid?areaId=' + areaId),

	/**
	 * 근무제 검색
	 * @method GET
	 * @param {INTEGER} workSystemId
	 *
	 */
	getWorkSystemById: (workSystemId) => get('/area/worksystemid?workSystemId=' + workSystemId),

	/**
	 * 연차 정보
	 * @param {INTEGER} companyId
	 * @param {INTEGER} userId
	 * @returns
	 */
	restdayInfo: (restday) => _get(`/restday/getRestInfo?${restday ? new URLSearchParams(restday).toString() : ''}`),

	/**
	 * 연차 내역
	 * @param {*} restday
	 * @returns
	 */
	restList: (restList) => get(`/request/rest/list?${restList ? new URLSearchParams(restList).toString() : ''}`),

	/**
	 * 중복 로그인 방지 스위치
	 * @returns
	 */
	securityDevice: (companyId, securityDevice) => _get(`/company/securityDevice?companyId=${companyId}&securityDevice=${securityDevice}`),

	/**
	 * 쿠폰전체출력
	 * @method GET
	 */
	getCoupon: () => get('/coupon/get'),

	/**
	 * 샘플 다운로드
	 */
	sampleDownload: async (type, name) => {
		const res = await _get('/userCompany/sampleDownload?type=' + type, {}, 'blob');
		if (res.data && res.status === 200) {

			const filename = `${name || type}.xlsx`;
			const file = new Blob([res.data], {
				type: 'text/plain;charset=utf-8',
			});

			FileSaver.saveAs(file, filename);
		}
	},

	/**
	 * 직원초대 관리자
	 */
	joinRequestAdmin: (invate) => post('/userCompany/joinRequestAdmin', invate),

	/**
	 * 엑셀 자동 가입 후 계정정보 메일 통지
	 */
	joinCompanyDirect: (invate) => post('/userCompany/joinCompanyDirect', invate),

	/**
	 * 기사용 휴가 업로드
	 */
	uploadRestXlsx: (data) => {
		const payload = createFormDataFromObject(data);

		return _post('/userCompany/uploadRestXlsx', payload)
	},

	/**
	 * 직원등록 관리자 목록
	 */
	memberAddList: (companyId) => get('/userCompany/registList?companyId=' + companyId),

	/**
	 * 직원초대 관리자 목록
	 */
	joinRequestAdminList: (companyId) => get('/userCompany/joinRequestAdminList?companyId=' + companyId),

	/**
	 * 직원초대 관리자 재발송
	 */
	joinRequestReply: (invateId) => get('/userCompany/joinRequestReply?id=' + invateId),

	/**
	 * 직원초대 관리자 삭제
	 */
	joinRequestRemove: (invateId) => get('/userCompany/joinRequestRemove?id=' + invateId),

	/**
	 * 쿠폰 추가
	 * @method POST
	 *
	 */
	registCoupon: (couponSettings) => post('/coupon', couponSettings),

	/**
	 * 쿠폰 수정
	 * @method PUT
	 * @param {OBJECT} couponSettings
	 *
	 */
	modifyCoupon: (couponSettings) => put('/coupon/modify', couponSettings),

	/**
	 * 쿠폰 삭제
	 * @method DELETE
	 * @param {INTEGER} couponId
	 *
	 */
	deleteCoupon: (couponId) => remove('/coupon/id?couponId=' + couponId),

	/**
	 * 쿠폰 상세
	 * @method GET
	 * @param {INTEGER} couponId
	 */
	detailCoupon: (couponId) => get('/coupon/detail?couponId=' + couponId),
	/* 요청관리 관리자 */
	getAdminRequestList: (compnayId) => _get(`/request/adminList/${compnayId}`),
	getAdminRequestList2: (info) => get(`/request/adminListRequest?${info ? new URLSearchParams(info).toString() : ''}`),

	/**
	 * 사용자 쿠폰 입력
	 * @method PUT
	 * @param {OBJECT} couponCode
	 *
	 */
	usecoupon: (couponCode) => put('/coupon/usecoupon', couponCode),

	/**
	 * 쿠폰 상세
	 * @method GET
	 * @param {INTEGER} couponId
	 */
	detailCouponHistory: (couponId) => get('/couponhistory/detail?couponId=' + couponId),

	/**
	 * 혜택 리스트
	 * @method GET
	 *
	 */
	getBenefitsList: () => get('/benefit/get'),

	/**
	 * 유저 쿠폰내역
	 * @method GET
	 * @param {INTEGER} userId
	 */
	getUsedCopon: (userId) => get('/coupon/user?userId=' + userId),

	/**
	 * 쿠폰 혜택 찾기
	 * @method GET
	 * @param {INTEGER} benefitsId
	 */
	getBenefits: (benefitsId) => get('/benefit/get?benefitsId=' + benefitsId),

	/**
	 * 사용자정보 수정
	 * @method PUT
	 * @param {OBJECT} userProfile
	 *
	 */
	modify: (userProfile) => _put('/userCompany/modify', userProfile),

	/**
	 * 결재 승인 (관리자)
	 */
	approvalRequest: (approval) => post('/request/approvalRequest', approval),

	/**
	 * 대시보드 통계 (관리자)
	 */
	attendReportToday: (info) =>  _get(`/request/attendReportToday?${info ? new URLSearchParams(info).toString() : ''}`),

	/**
	 * 근무 신청
	 * @param {*} workday
	 * @returns
	 */
	workdayRequest: (workday) => _post('/attend/workday-request', workday),

	/**
	 * 휴가 정책 설정
	 */
	vaction: (vaction) => _put(`/company/vaction`, vaction),

	/**
	 * 근무 정책 설정
	 */
	workPolicy: (workPolicy) => _put(`/company/workPolicy`, workPolicy),

	/**
	 * 회사 인원
	 * @param {*} companyId
	 * @returns
	 */
	getCompanyUserList: (companyId) => _get('/company/usersLists?companyId=' + companyId),

	/**
	 * 동료 근무 기록
	 * @param {*} companyId
	 * @param {*} departId
	 * @returns
	 */
	getWorkLogsByDepart: (companyId, departId, sdate, edate) => get(`/attend/log/depart/${companyId}/${departId}?sdate=${sdate}&edate=${edate}`),
	dashboardAttendLog: (companyId) => get('/attend/dashboard/attendLog?companyId=' + companyId),
	dashboardAttendLogsGroups: (companyId, groupId) => _get('/attend/dashboard/attendLogsGroups?companyId=' + companyId + '&groupId=' + groupId),
	workTimeOver: (companyId, filters = null) => _get(`/company/workTime/${companyId}${filters ? '?' + new URLSearchParams(filters).toString() : ''}`),
	approvalCheck: (companyId, data) => _put(`/approval/${companyId}/check`, data),
	//getEApproval: (companyId, userId) => get(`/e-approval/${companyId}/${userId}`),
	getEApproval: (companyId, userId, filters = null) => _get(`/e-approval/${companyId}/${userId}${filters ? '?' + new URLSearchParams(filters).toString() : ''}`),
	getAbsenteeAll: (companyId, userId) => _get(`/absentee?companyId=${companyId}&userId=${userId}`),
	addAbsentee: (absenteeData) => _post(`/absentee`, absenteeData),
	modifyAbsentee: (absenteeData) => _put(`/absentee`, absenteeData),
	deleteAbsentee: (absenteeId) => _remove('/absentee?absenteeId=' + absenteeId),

	/**
	 * 전자결재 함수
	 * @param {serial} id        request PK ID
	 * @param {int} companyId 회사 PK ID
	* @param {int} userId      결재 사용자 정보
	 * @param {int} y         결재 순서 y
	 * @param {int} x         결재 순서 x
	 * @param {string} state     결재 상태
	 */
	approval: (request) => _post('/request/approval', request),
	who: (companyId, requestId) => get(`/e-approval/who/${companyId}/${requestId}`),

	/**
	 * 신청 상세
	 * @returns
	 */
	requestDetail: (request) => _get('/request/detail?id=' + request),

	/**
	 * COMM_CODE 조회
	 */
	getCommCode: (compNo, commCodeType) => _get('/commonCode?compNo=' + compNo + '&commCodeType=' + commCodeType),

	/**
	 * COMM_CODE 조회(NEW)
	 */
	getCommCodeNew: (commCode) => _get('/commonCodeNew', commCode),

	/**
	 * 권한 별 회사 인원 조회
	 * @param {int} companyId
	 * @param {string} type
	 */
	getCompanyUserListByPermissions: (companyId, type) => _get(`/company/usersListsByPermissions?companyId=${companyId}&type=${type}`),

	/**
	 * 권한 별 회사 인원 & 해당 인원의 restInfo 조회
	 * @param page
	 * @param size
	 * @param companyId
	 * @param filters
	 * @returns {Promise<AxiosResponse<any>>}
	 */
	getUserRestInfoPage: (page, size, companyId, filters) => {
		const params = new URLSearchParams({ page, size, companyId, ...(!isEmpty(filters) && { filters: JSON.stringify(filters) }) });
		return _get(`/restday/userRestInfos?${params}`);
	},

	/**
	 * 직원 목록 페이징 API
	 * @param companyId
	 * @param size
	 * @param page
	 * @param filters
	 * @returns {Promise<AxiosResponse<any>>}
	 */
	getEmployeeListByPermissionsPage: (companyId, size, page, filters) => {
		const params = new URLSearchParams({ companyId, ...(size && { size }), ...(page && { page }), ...(!isEmpty(filters) && { filters: JSON.stringify({ ...filters, deparmentList: filters.departments }) }) });
		return _get(`/company/employeeList?${params}`);
	},

	gpsCheck: area => _get(`/attend/gpsCheck?${area ? new URLSearchParams(area).toString() : ''}`),

	getAllAllowPc: (companyId) => get(`/ip-allowed/check-allowed-all/${companyId}`),
	putAllowPc: (data) => _put(`/ip-allowed/allowed-all`, data),
	addAllowPc: (data) => _post(`/ip-allowed/add `, data),
	editAllowPc: (data) => _put(`/ip-allowed/edit`, data),
	deleteAllowPc: (id, payload) => _remove(`/ip-allowed/delete/${id}`, payload),
	getListAllowPc: (companyId) => get(`/ip-allowed/list/${companyId}`),
	getPlanRequestList: ({ companyId, year, userId }) => _get(`/request/plan-annual-leave/list?companyId=${companyId}&year=${year}&userId=${userId}`),
	getYearPlanRequestList: ({ companyId, userId }) => _get(`/request/plan-annual-leave/year?companyId=${companyId}&userId=${userId}`),
	getLeavePromotionList: ({ companyId, page, size, filters }) => _get(`/email/sendHistoryPage?companyId=${companyId}&page=${page}&size=${size}&filters=${filters ? JSON.stringify(filters) : ''}`),
	// 연차계획 상태별 집계 (대시보드/휴가관리 연차계획신청 현황 카드) → { total, success, request, reject, cancel, none, noneWithRemaining }
	getAnnualLeavePlanSummary: ({ companyId, year, filters }) => _get(`/email/annualLeavePlanSummary?companyId=${companyId}${year ? `&year=${year}` : ''}${filters ? `&filters=${JSON.stringify(filters)}` : ''}`),
	getLeavePromotionDetail: ({ companyId, userId, year, requestId }) => _get(`/email/sendHistoryDetail?companyId=${companyId}&userId=${userId}&year=${year}&requestId=${requestId}`),
	getAssignmentLeaveList: ({ companyId, page, size, filters }) => _get(`/email/assignLeavePlan?companyId=${companyId}&page=${page}&size=${size}&filters=${filters ? JSON.stringify(filters) : ''}`),
	getEmailStatusList: ({ companyId, page, size, filters }) => _get(
		`/email/sendHistoryStatus?companyId=${companyId}&page=${page}&size=${size}&filters=${filters ? JSON.stringify(filters) : ''}`
	),
	getAssignmentDetail: ({ companyId, userId, year }) => _get(
		`/request/assignLeavePlanDetail?companyId=${companyId}&userId=${userId}&year=${year}`
	),
	sendAnnualLeavePromotion: (payload) => _post(`/email/sendAnnualLeavePromotion`, payload),
	getHistoryDetails: (payload) => _post(`/email/sendHistoryDetailExcel`, payload),
	sendRandomAssignment: (payload) => _post(`/request/random-assign-leave-plan`, payload),
	getEmailTemplete: (companyId, emailType) => _get(`/email/readEmailTemplete?companyId=${companyId}&emailType=${emailType}`),
	getYearList: () => _get(`/user-al-except/get-year-list`),
	getCommonCodeTableSetting: (payload) => _post(`/comm-mst/mst-list`, payload),
	getCommonDetailCodeTableSetting: (payload) => _get(`/comm-mst/dtl-list`, payload),
	saveDetailCodeTableSetting: (payload) => _post(`/comm-mst/dtl-save`, payload),
	saveCommonCodeTableSetting: (payload) => _post(`/comm-mst/mst-save`, payload),
	getColsDetailCodeTableSetting: (payload) => _get(`/comm-mst/dtl-cols-etc`, payload),
	getCmAdditionItems: (mstId) => _get(`/comm-mst/dtl-attr-list?mstId=${mstId}`),
	saveCmAdditionItems: (payload) => _post(`/comm-mst/dtl-attr-save`, payload),
	getCommonDetailCodeListSelected: (payload) => _get(`/comm-mst/dtl/${payload}`),
	/**
	 * 출산휴가 사용가능여부 체크
	 */
	chkMatAvailable: (companyId, userId, pregnancyId) => _get(
		`/request/chkMatAvailable?companyId=${companyId}&userId=${userId}&pregnancyId=${pregnancyId}`
	),

	getDataCompensatoryLeave:(payload) => _post(`/compensatory-leave/list`, payload),
	generateCompensatoryLeave:(payload) => _post(`/compensatory-leave/user-generate`, payload),
	getDataGeneratedHistoryCompensatoryLeave:({date}) => _get(`/compensatory-leave/user-daily-generated-list?date=${date}`),
	getEligibleEmployees:(payload) => _post(`/compensatory-leave/eligible-employees`, payload),
	getOvertimeDetails:(payload) => _post(`/compensatory-leave/overtime-details`, payload),
};
